import React, { FC } from 'react';
import { connect, useSelector } from 'react-redux';
import { reduxForm } from 'redux-form';
import {
  REQUEST_TUTORING_FORM_NAME,
  RequestTutoringFormValues,
  validateRequestTutoringForm,
} from './request-tutoring-form.logic';
import { HoursStep, LevelStep, SubjectStep, TutoringTypeStep } from './steps';
import { RequestTutoringSteps } from 'logic/store/offer/offer.model';
import {
  getRequestTutoringFlow,
  getRequestTutoringFlowCurrIdx,
} from 'logic/store/request-tutoring/request-tutoring.selectors';
import { StoreState } from 'app/app.reducers';
import { FormContainer } from 'components/form-container/form-container';

const RequestTutoring: FC = () => {
  const stepNumber = useSelector(getRequestTutoringFlowCurrIdx);
  const flow = useSelector(getRequestTutoringFlow);
  const step = flow[stepNumber];

  const getStepComponent = () => {
    switch (step) {
      case RequestTutoringSteps.Subject:
        return <SubjectStep />;
      case RequestTutoringSteps.TutoringType:
        return <TutoringTypeStep />;
      case RequestTutoringSteps.Level:
        return <LevelStep />;
      case RequestTutoringSteps.Hours:
        return <HoursStep />;
      default:
        return null;
    }
  };

  return <FormContainer>{getStepComponent()}</FormContainer>;
};

export const RequestTutoringForm = connect(({ offer }: StoreState): {
  initialValues: RequestTutoringFormValues;
} => ({
  // prefill form with initial values
  initialValues: offer.offerRequestInitValues,
}))(
  reduxForm({
    form: REQUEST_TUTORING_FORM_NAME,
    enableReinitialize: true,
    destroyOnUnmount: true,
    validate: validateRequestTutoringForm,
  })(RequestTutoring)
);
